export enum InvestmentObjectiveEnum {
    start_investing = 'start_investing',
    to_experiment = 'to_experiment',
    start_day_trader = 'start_day_trader',
    operates_day_trader = 'operates_day_trader',
}

export enum InvestmentKeyEnum {
    objective = 'objective'
}